import { createAction, ActionType } from 'typesafe-actions';

export const operationsActions = {
    init: createAction('OPERATION_INIT')<string>(),
    pending: createAction('OPERATION_SET_STATUS_PENDING')<string>(),
    success: createAction('OPERATION_SET_STATUS_SUCCESS')<string>(),
    fail: createAction('OPERATION_SET_STATUS_FAIL')<{ id: string, error?: any, error_message?: string }>(),
    clear: createAction('OPERATION_CLEAR')<string>(),
    setMeta: createAction('OPERATION_SET_META')<{ id: string, meta }>(),
    setData: createAction('OPERATION_SET_DATA')<{ id: string, data }>(),
    updateData: createAction('OPERATION_UPDATE_DATA')<{ id: string, data }>()
};

export type TOperationsActions = ActionType<typeof operationsActions>;
